import { render, staticRenderFns } from "./cTypeSpent.vue?vue&type=template&id=1610b600&"
import script from "./cTypeSpent.vue?vue&type=script&lang=js&"
export * from "./cTypeSpent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports